import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SvgIconModule } from '../../../svg-icon/svg-icon.module';
import { HubAuthorizationHeaderComponent } from './hub-authorization-header.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [HubAuthorizationHeaderComponent],
    declarations: [HubAuthorizationHeaderComponent],
})
export class HubAuthorizationHeaderModule { }
